import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    dialogTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    dropZone: {
      minHeight: '170px',
      height: '210px'
    },
    previewChip: {
      minWidth: 160,
      maxWidth: 210,
      padding: theme.spacing(2)
    },
    dialogActionsRoot: {
      margin: '14px'
    },
    childrenWrapper: {
      marginBottom: theme.spacing(4)
    },
    childrenWrapperCompact: {
      marginBottom: 0,
      '& .MuiToolbar-root': {
        minHeight: 0
      }
    }
  })
